import React from 'react'
import Describe from '../../components/Description';
import { useSelector } from 'react-redux';
const VesselRow = (props) => {
    const {selectedVessel} = useSelector((state)=>state.vessel)
    return (
        <div className="card vessel-card" id={selectedVessel?.casper_id===props.number ? "card-active":""}>
            <Describe {...props}/>
        </div>
    )
}

export default VesselRow


